'use client';

import { Language } from '@coolblue-development/constants';
import { freddyTheme } from '@coolblue-development/freddy';
import { useRequestContext } from '@coolblue-development/next-request-context/client';

export default function FreeWashingIcon() {
  const { language } = useRequestContext();

  const pathStyle = {
    fill: freddyTheme.color.background.interactiveControlSelectedBase
  };

  const backgroundStyle = {
    fill: freddyTheme.color.background.interactiveControlBase
  };

  const NLPath = (
    <g>
      <path
        style={backgroundStyle}
        d='M962.59,260.45h-5.01v-48.88c0-26.07-21.12-47.31-47.13-47.31s-47.19,21.24-47.19,47.31v48.88h-7.27v-48.88c0-26.07-21.18-47.31-47.19-47.31-1.94,0-3.84.15-5.71.38C717.28,60.92,589.27,0,453.51,0,203.44,0,0,203.44,0,453.51s203.44,453.51,453.51,453.51c234.89,0,428.51-179.51,451.17-408.53,54.21-11.46,95.32-60.29,95.32-117.66v-82.85c0-20.68-16.79-37.54-37.41-37.54Z'
      />
      <g>
        <g>
          <path
            style={pathStyle}
            d='M241.17,317.64c10.25,0,28.54,1,42.2,4.22v30.95h-18.69v-12.46h-19.49c-28.13,0-32.76,26.12-32.76,47.63s4.42,47.83,28.74,47.83h16.48v-35.17h-20.5v-18.09h46.22v71.54c-13.67,3.21-31.95,4.22-42.2,4.22-45.21,0-55.26-36.17-55.26-70.34s10.05-70.34,55.26-70.34Z'
          />
          <path
            style={pathStyle}
            d='M296.42,456.3v-18.49h11.05v-63.3h-11.05v-18.69h33.16l2.01,16.68h.4c6.63-13.67,19.49-18.69,31.75-18.69v23.71h-6.03c-18.29,0-26.12,9.04-26.12,20.5v39.79h15.07v18.49h-50.24Z'
          />
          <path
            style={pathStyle}
            d='M373.79,373.91v-15.88c13.47-2.61,27.13-4.22,38.58-4.22,24.32,0,38.18,6.83,38.18,33.36v50.64h12.06v18.49h-34.17l-2.01-11.45h-.4c-8.04,10.65-16.68,13.46-28.74,13.46-19.09,0-30.15-13.06-30.15-30.55,0-24.11,17.08-30.75,33.96-30.75h25.32v-8.84c0-9.24-3.21-14.27-16.48-14.27h-36.17ZM426.44,412.29h-18.69c-10.45,0-16.48,4.42-16.48,13.87s7.63,13.46,16.08,13.46,19.09-5.43,19.09-18.49v-8.84Z'
          />
          <path
            style={pathStyle}
            d='M478.68,431.18v-56.67h-12.06v-14.67l14.07-4.02,9.04-28.13h13.06v28.13h25.12v18.69h-25.12v54.66c0,6.63,2.81,9.04,10.05,9.04h15.07v15.88c-8.04,2.81-13.26,4.22-21.1,4.22-21.5,0-28.14-11.86-28.14-27.13Z'
          />
          <path
            style={pathStyle}
            d='M535.95,456.3v-18.49h11.05v-63.3h-11.05v-18.69h35.17v81.99h11.06v18.49h-46.22ZM571.12,315.63v27.13h-24.11v-27.13h24.11Z'
          />
          <path
            style={pathStyle}
            d='M634.42,353.81c11.65,0,19.09,1,32.55,4.22v15.88h-31.55c-13.27,0-16.68,5.23-16.68,9.65,0,5.02,2.61,9.44,15.47,12.06,18.89,3.62,37.78,8.84,37.78,31.55s-17.48,31.15-41.2,31.15c-11.66,0-25.12-1-38.58-4.22v-15.88h37.38c12.86,0,16.28-6.43,16.28-11.05,0-5.02-2.61-8.84-15.48-11.45-18.89-3.62-37.78-8.04-37.78-32.15,0-21.1,18.29-29.74,41.8-29.74Z'
          />
          <path
            style={pathStyle}
            d='M288.93,527.59l-18.67,63.04h-20.5l-12.24-45.14h-.31l-11.78,45.14h-20.2l-19.13-63.04h-7.96v-14.23h35.5v14.23h-7.65l11.17,37.49h.31l12.7-51.71h16.37l13.47,51.71h.31l10.1-37.49h-7.35v-14.23h33.97v14.23h-8.11Z'
          />
          <path
            style={pathStyle}
            d='M303.14,527.13v-12.09c10.25-1.99,20.66-3.21,29.38-3.21,18.51,0,29.07,5.2,29.07,25.4v38.56h9.18v14.08h-26.01l-1.53-8.72h-.31c-6.12,8.11-12.7,10.25-21.88,10.25-14.54,0-22.95-9.95-22.95-23.26,0-18.36,13.01-23.41,25.86-23.41h19.28v-6.73c0-7.04-2.45-10.86-12.55-10.86h-27.54ZM343.23,556.35h-14.23c-7.96,0-12.55,3.37-12.55,10.56s5.82,10.25,12.24,10.25,14.54-4.13,14.54-14.08v-6.73Z'
          />
          <path
            style={pathStyle}
            d='M409.78,511.83c8.87,0,14.53.77,24.78,3.21v12.09h-24.02c-10.1,0-12.7,3.98-12.7,7.34,0,3.83,1.99,7.19,11.78,9.18,14.38,2.76,28.76,6.73,28.76,24.02s-13.31,23.72-31.37,23.72c-8.87,0-19.13-.77-29.38-3.21v-12.09h28.46c9.79,0,12.39-4.9,12.39-8.41,0-3.83-1.99-6.73-11.78-8.72-14.38-2.75-28.76-6.12-28.76-24.48,0-16.06,13.93-22.64,31.83-22.64Z'
          />
          <path
            style={pathStyle}
            d='M478.16,511.83c8.87,0,14.54.77,24.79,3.21v12.09h-24.02c-10.1,0-12.7,3.98-12.7,7.34,0,3.83,1.99,7.19,11.78,9.18,14.38,2.76,28.76,6.73,28.76,24.02s-13.31,23.72-31.36,23.72c-8.87,0-19.13-.77-29.38-3.21v-12.09h28.46c9.79,0,12.39-4.9,12.39-8.41,0-3.83-1.99-6.73-11.78-8.72-14.38-2.75-28.76-6.12-28.76-24.48,0-16.06,13.92-22.64,31.82-22.64Z'
          />
          <path
            style={pathStyle}
            d='M534.62,557.12c.61,11.01,4.43,18.97,15.76,18.97h26.77v12.09c-10.4,2.45-18.97,3.21-26.77,3.21-25.7,0-35.19-15.76-35.19-39.78s11.17-39.78,37.03-39.78c20.66,0,30.3,11.94,30.3,23.72,0,10.86-4.59,21.57-22.65,21.57h-25.24ZM534.92,545.49h19.13c7.34,0,10.1-4.28,10.1-8.87,0-4.9-4.44-9.49-12.24-9.49-10.86,0-15.91,7.65-16.98,18.36Z'
          />
          <path
            style={pathStyle}
            d='M636.81,589.86v-14.08h7.65v-38.71c0-7.5-6.12-10.86-12.7-10.86s-14.84,4.44-14.84,13.92v35.65h8.41v14.08h-35.19v-14.08h8.41v-48.2h-8.41v-14.23h25.25l1.53,8.87h.31c5.81-7.35,13.31-10.4,22.64-10.4,15.61,0,22.95,9.95,22.95,23.72v40.24h8.41v14.08h-34.42Z'
          />
        </g>
        <path
          style={pathStyle}
          d='M961.06,285.44h-30.08v-73.95c0-12.28-9.9-22.25-22.06-22.25s-22.12,9.96-22.12,22.25v73.95h-57.4v-73.95c0-12.28-9.9-22.25-22.12-22.25s-22.06,9.96-22.06,22.25v73.95h-30.02c-6.83,0-12.41,5.58-12.41,12.47v82.85c0,51.14,40.04,92.87,90.24,95.13h4.58c-11.72,202.73-179.73,363.53-385.4,363.53-6.08,0-12.1-.13-18.24-.44-197.84-9.09-358.39-169.64-367.48-367.48C56.59,256.3,222.91,77.7,433.4,67.55c10.53-.5,18.8-9.09,18.8-19.61s-8.9-19.8-19.74-19.8h-.94C199.72,39.28,15.98,236.75,27.07,473.63c10.21,217.83,187,394.61,404.83,404.76,6.77.31,13.6.5,20.3.5,226.73,0,412.53-178.16,424.94-401.88h.69v-1.13h3.26c51.14-1.19,92.31-43.3,92.31-95.13v-82.85c0-6.89-5.51-12.47-12.35-12.47ZM917.57,413.84c-1.69,5.33-6.83,8.84-11.22,11.78-14.48,9.78-31.65,14.41-48.88,14.41-6.14,0-12.28-.56-18.3-1.75-21.37-4.07-40.3-15.98-53.45-33.21-6.96-9.21-20.74-29.64-2.88-36.53,2-.75,3.82-1.13,5.39-1.13,9.21,0,12.85,11.15,17.74,18.24,5.7,8.27,13.35,15.17,22.37,19.8,8.71,4.45,19.68,7.02,30.64,7.02,13.29,0,26.57-3.82,35.66-12.72.06-.06.19-.13.25-.19l-.06-.06.19-.13.06.06c2.69-2.38,5.76-3.57,8.84-3.57,8.59,0,16.73,8.21,13.66,17.99Z'
        />
      </g>
    </g>
  );

  const ENPath = (
    <g>
      <path
        style={backgroundStyle}
        d='M962.59,260.45h-5.01v-48.88c0-26.07-21.12-47.31-47.13-47.31s-47.19,21.24-47.19,47.31v48.88h-7.27v-48.88c0-26.07-21.18-47.31-47.19-47.31-1.94,0-3.84.15-5.71.38C717.28,60.92,589.27,0,453.51,0,203.44,0,0,203.44,0,453.51s203.44,453.51,453.51,453.51c234.89,0,428.51-179.51,451.17-408.53,54.21-11.46,95.32-60.29,95.32-117.66v-82.85c0-20.68-16.79-37.54-37.41-37.54Z'
      />
      <path
        style={pathStyle}
        d='M962.59,285.44h-30.08v-73.95c0-12.28-9.9-22.25-22.06-22.25s-22.12,9.96-22.12,22.25v73.95h-57.4v-73.95c0-12.28-9.9-22.25-22.12-22.25s-22.06,9.96-22.06,22.25v73.95h-30.02c-6.83,0-12.41,5.58-12.41,12.47v82.85c0,51.14,40.04,92.87,90.24,95.13h4.58c-11.72,202.73-179.73,363.53-385.4,363.53-6.08,0-12.1-.13-18.24-.44-197.84-9.09-358.39-169.64-367.48-367.48C58.12,256.3,224.44,77.7,434.93,67.55c10.53-.5,18.8-9.09,18.8-19.61s-8.9-19.8-19.74-19.8h-.94C201.25,39.28,17.51,236.75,28.6,473.63c10.21,217.83,187,394.61,404.83,404.76,6.77.31,13.6.5,20.3.5,226.73,0,412.53-178.16,424.94-401.88h.69v-1.13h3.26c51.14-1.19,92.31-43.3,92.31-95.13v-82.85c0-6.89-5.51-12.47-12.35-12.47ZM919.1,413.84c-1.69,5.33-6.83,8.84-11.22,11.78-14.48,9.78-31.65,14.41-48.88,14.41-6.14,0-12.28-.56-18.3-1.75-21.37-4.07-40.3-15.98-53.45-33.21-6.96-9.21-20.74-29.64-2.88-36.53,2-.75,3.82-1.13,5.39-1.13,9.21,0,12.85,11.15,17.74,18.24,5.7,8.27,13.35,15.17,22.37,19.8,8.71,4.45,19.68,7.02,30.64,7.02,13.29,0,26.57-3.82,35.66-12.72.06-.06.19-.13.25-.19l-.06-.06.19-.13.06.06c2.69-2.38,5.76-3.57,8.84-3.57,8.59,0,16.73,8.21,13.66,17.99Z'
      />
      <g>
        <path
          style={pathStyle}
          d='M193.43,468.01v-24.69h14.77v-132.9h-14.77v-24.97h127.54v44.3h-24.97v-14.76h-53.69v53.15h68.45v29.53h-68.45v45.65h14.76v24.69h-63.63Z'
        />
        <path
          style={pathStyle}
          d='M327.7,468.01v-24.69h14.77v-84.57h-14.77v-24.97h44.3l2.67,22.28h.54c8.86-18.26,26.05-24.96,42.42-24.96v31.67h-8.05c-24.43,0-34.91,12.08-34.91,27.38v53.16h20.14v24.69h-67.11Z'
        />
        <path
          style={pathStyle}
          d='M458.47,410.55c1.07,19.33,7.77,33.29,27.65,33.29h46.98v21.21c-18.26,4.29-33.28,5.64-46.98,5.64-45.11,0-61.75-27.66-61.75-69.8s19.59-69.8,64.97-69.8c36.25,0,53.16,20.93,53.16,41.61,0,19.06-8.05,37.85-39.74,37.85h-44.29ZM459,390.15h33.56c12.89,0,17.73-7.51,17.73-15.57,0-8.6-7.79-16.65-21.47-16.65-19.06,0-27.93,13.42-29.81,32.22Z'
        />
        <path
          style={pathStyle}
          d='M592.73,410.55c1.07,19.33,7.79,33.29,27.65,33.29h46.99v21.21c-18.26,4.29-33.29,5.64-46.99,5.64-45.09,0-61.75-27.66-61.75-69.8s19.61-69.8,64.98-69.8c36.25,0,53.15,20.93,53.15,41.61,0,19.06-8.05,37.85-39.73,37.85h-44.3ZM593.27,390.15h33.56c12.89,0,17.71-7.51,17.71-15.57,0-8.6-7.77-16.65-21.47-16.65-19.06,0-27.91,13.42-29.79,32.22Z'
        />
        <path
          style={pathStyle}
          d='M287.86,539.98l-16.13,54.49h-17.73l-10.58-39.01h-.27l-10.18,39.01h-17.46l-16.53-54.49h-6.88v-12.3h30.68v12.3h-6.61l9.65,32.4h.27l10.98-44.7h14.15l11.64,44.7h.26l8.73-32.4h-6.35v-12.3h29.36v12.3h-7.01Z'
        />
        <path
          style={pathStyle}
          d='M300.18,539.58v-10.45c8.86-1.72,17.86-2.77,25.39-2.77,16,0,25.13,4.5,25.13,21.95v33.33h7.94v12.16h-22.48l-1.33-7.54h-.27c-5.29,7.01-10.98,8.86-18.91,8.86-12.56,0-19.83-8.6-19.83-20.11,0-15.87,11.24-20.23,22.34-20.23h16.67v-5.82c0-6.08-2.11-9.39-10.85-9.39h-23.81ZM334.83,564.85h-12.3c-6.88,0-10.85,2.91-10.85,9.12s5.03,8.86,10.59,8.86,12.56-3.57,12.56-12.16v-5.82Z'
        />
        <path
          style={pathStyle}
          d='M392.37,526.36c7.68,0,12.56.66,21.42,2.77v10.45h-20.77c-8.72,0-10.98,3.44-10.98,6.35,0,3.3,1.72,6.21,10.19,7.94,12.43,2.38,24.86,5.81,24.86,20.76s-11.51,20.51-27.12,20.51c-7.67,0-16.53-.67-25.39-2.78v-10.45h24.6c8.46,0,10.71-4.23,10.71-7.28,0-3.3-1.72-5.81-10.18-7.54-12.43-2.37-24.86-5.29-24.86-21.16,0-13.89,12.03-19.57,27.51-19.57Z'
        />
        <path
          style={pathStyle}
          d='M462.74,593.81v-12.16h6.61v-33.47c0-6.48-5.29-9.39-10.98-9.39s-12.83,3.84-12.83,12.04v30.82h7.28v12.16h-30.42v-12.16h7.28v-68.11h-7.28v-12.3h23.14v34.13h.27c5.02-6.35,11.51-8.99,19.57-8.99,13.49,0,19.84,8.59,19.84,20.5v34.78h7.28v12.16h-29.76Z'
        />
        <path
          style={pathStyle}
          d='M497.14,593.81v-12.16h7.28v-41.66h-7.28v-12.3h23.15v53.96h7.27v12.16h-30.42ZM520.29,501.23v17.86h-15.87v-17.86h15.87Z'
        />
        <path
          style={pathStyle}
          d='M572.54,593.81v-12.16h6.61v-33.47c0-6.48-5.29-9.39-10.98-9.39s-12.83,3.84-12.83,12.04v30.82h7.28v12.16h-30.42v-12.16h7.27v-41.66h-7.27v-12.3h21.82l1.33,7.68h.27c5.02-6.35,11.51-8.99,19.57-8.99,13.49,0,19.84,8.59,19.84,20.5v34.78h7.27v12.16h-29.75Z'
        />
        <path
          style={pathStyle}
          d='M666.46,539.98v47.22c0,20.76-8.2,34.39-30.43,34.39-6.74,0-13.62-.67-22.48-2.78v-10.45h23.28c10.72,0,13.76-8.2,13.76-19.17v-2.91h-.27c-4.76,6.21-9.65,8.86-17.33,8.86-17.46,0-24.73-13.23-24.73-33.99s9.52-33.46,30.02-33.46h35.44v12.3h-7.27ZM650.59,540.51h-11.24c-10.85,0-14.42,8.72-14.42,20.63s2.25,21.29,13.36,21.29c5.55,0,12.3-3.84,12.3-12.03v-29.89Z'
        />
      </g>
    </g>
  );

  return (
    <svg
      height={60}
      width={60}
      id='Layer_2'
      data-name='Layer 2'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 1000 907.02'
    >
      <g id='Layer_1-2' data-name='Layer 1'>
        {language === Language.DUTCH ? NLPath : ENPath}
      </g>
    </svg>
  );
}
